import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Typography from '@segment/matcha/components/Typography';
export var Title = /*#__PURE__*/_styled(Typography, true ? {
  target: "enok57o0"
} : {
  target: "enok57o0",
  label: "Title"
})(true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQWNjb3JkaW9uL1RpdGxlL1RpdGxlLnZpZXdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU11QyIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL0FjY29yZGlvbi9UaXRsZS9UaXRsZS52aWV3cy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5pbXBvcnQgVHlwb2dyYXBoeSBmcm9tICdAc2VnbWVudC9tYXRjaGEvY29tcG9uZW50cy9UeXBvZ3JhcGh5J1xuaW1wb3J0IHR5cGUgeyBUeXBvZ3JhcGh5UHJvcHMgfSBmcm9tICdAc2VnbWVudC9tYXRjaGEvY29tcG9uZW50cy9UeXBvZ3JhcGh5L1R5cG9ncmFwaHkudmlld3MnXG5cbmV4cG9ydCB0eXBlIFRpdGxlVG9rZW5zID0gVHlwb2dyYXBoeVByb3BzXG5leHBvcnQgY29uc3QgVGl0bGUgPSBzdHlsZWQoVHlwb2dyYXBoeSlgXG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIG1hcmdpbjogMTZweCAwO1xuICB0cmFuc2l0aW9uOiAzMDBtcyBjb2xvcjtcbmBcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});